import React from 'react';
import { Typography, Box, Popover, ClickAwayListener } from '@material-ui/core';



/**
 * This component is a popover shows help for the Calendar
 * 
 * The user can supply the following props:
 * 
 * isOpen (boolean): True if the popover is open, false otherwise
 * onClose (function): A callback function that is called when the popover is closed
 * anchor (element): The element that the popover is anchored to
 */
export function CalendarHelpPopover(props) {
    const nav = typeof navigator !== 'undefined' ? navigator : null;
    const platform = nav ? ((nav.userAgentData && nav.userAgentData.platform) ? nav.userAgentData.platform : (nav.platform || '')) : '';
    const isMacPlatform = /Mac|iPhone|iPad|iPod/i.test(platform);
    const modifierKeySymbol = isMacPlatform ? '⌘' : '⌃';
    const addButtonStyle = {
        display: 'inline-block',
        backgroundColor: '#89f289',
        border: '1px solid black',
        borderRadius: 4,
        padding: '0 4px',
        fontWeight: 'bold',
        marginLeft: 2,
        marginRight: 2
    };
   
    return (
        <Popover open={props.isOpen} anchorEl={props.anchor} 
                anchorOrigin={{vertical: 'center', horizontal: 'left'}} 
                transformOrigin={{vertical: 'top', horizontal: 'right'}}>
        
            <ClickAwayListener onClickAway={props.onClose}>
                <Box style={{margin: 20, width: 360}}>
                    <Typography variant="subtitle1" style={{fontWeight: 'bold'}}>Calendar Quick Help</Typography>  

                    <Typography variant="subtitle2" style={{fontWeight: 'bold', marginTop: 12}}>Copy / Paste Items</Typography>
                    <Typography variant="body2">
                        Use <b>{modifierKeySymbol}C</b> / <b>{modifierKeySymbol}V</b> to copy and paste.
                        Highlight a calendar item, copy it, select a new slot on the calendar, and paste it there.
                    </Typography>

                    <Typography variant="subtitle2" style={{fontWeight: 'bold', marginTop: 12}}>Move an Item</Typography>
                    <Typography variant="body2">
                        Select then drag a calendar item from one spot on the calendar to another to move it to a new time.
                    </Typography>

                    <Typography variant="subtitle2" style={{fontWeight: 'bold', marginTop: 12}}>Change Start/Duration</Typography>
                    <Typography variant="body2">
                        Stretch an item by dragging its top or bottom edge to change the start time change duration.
                    </Typography>

                    <Typography variant="subtitle2" style={{fontWeight: 'bold', marginTop: 12}}>Add Item by Double Click</Typography>
                    <Typography variant="body2">
                        Double click on a time slot to start adding a new calendar item there.
                    </Typography>

                    <Typography variant="subtitle2" style={{fontWeight: 'bold', marginTop: 12}}>Add Item by Range Select</Typography>
                    <Typography variant="body2">
                        Click a time slot and drag to select a time range, then press the <span style={addButtonStyle}>+</span> button to add a new calendar item in that range.
                    </Typography>

                    <Typography variant="subtitle2" style={{fontWeight: 'bold', marginTop: 12}}>Delete an Item</Typography>
                    <Typography variant="body2">
                        Press <b>Delete</b> or <b>Backspace</b> to remove the currently selected item.
                    </Typography>

                    <Typography variant="subtitle2" style={{fontWeight: 'bold', marginTop: 12}}>Jump to Day View</Typography>
                    <Typography variant="body2">
                        Click on a date to jump to the day view for that date.
                    </Typography>
                </Box>
            </ClickAwayListener>

        </Popover>
    );
}